var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChartTreeInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_7264",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 7264",
    transform: "translate(-189.063)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_48574",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 48574",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(189.063)",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5801",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 5801",
    d: "M2.544,0H1.456V-7.488H2.544Zm.224-10.368a.709.709,0,0,1-.24.552A.773.773,0,0,1,2-9.6a.773.773,0,0,1-.528-.216.709.709,0,0,1-.24-.552.709.709,0,0,1,.24-.552A.773.773,0,0,1,2-11.136a.773.773,0,0,1,.528.216A.709.709,0,0,1,2.768-10.368Z",
    transform: "translate(197.063 15)",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTreeInfoIcon);
export default __webpack_public_path__ + "static/media/chartTreeInfoIcon.577411b6.svg";
export { ForwardRef as ReactComponent };